import React from "react";
import ProjectsListTable from "./projects-list-table/ProjectsListTable";

export default function ProjectsList({ projects = [], onChangeArchive, onChangeName, onClickRow, selectedProject }) {
	return (
		<ProjectsListTable
			projects={projects}
			selectedProject={selectedProject}
			onChangeArchive={onChangeArchive}
			onChangeName={onChangeName}
			onClickRow={onClickRow}
		/>
	);
}
